const isDev = process.env.NODE_ENV !== 'production';

export const logError = (context, error) => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.error(`[${context}]`, error);
  }
};

export const logWarn = (context, message) => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.warn(`[${context}]`, message);
  }
};
